/*
 * File: ResourceCalendarView.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 05/21/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates the calendar using react-big-calendar
 */

import React from "react";
import { withTheme } from "@material-ui/styles";
import AppointmentBlock from "./AppointmentBlock";
import { Calendar } from "react-big-calendar";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import localizer from "./Localizer";
import Appointment from "./Appointment";

const ResourceCalendarView = withTheme(
  observer(({ parent, resource, theme }) => {
    const { classes } = parent.props;

    return (
      <div className={classes.calendar}>
        <Calendar
          localizer={localizer}
          components={{
            day: {
              event: Appointment
            }
          }}
          showMultiDayTimes
          min={parent.min}
          max={parent.max}
          selectable
          step={15}
          timeslots={2}
          toolbar={false}
          date={parent.apptDate}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onNavigate={() => {}}
          defaultView="day"
          views={["day"]}
          events={parent.getEvents(resource)}
          resources={[resource]}
          resourceIdAccessor="resourceId"
          resourceTitleAccessor="name"
          onSelecting={parent.onSelecting}
          onSelectEvent={parent.onSelectEvent}
          eventPropGetter={event => AppointmentBlock(event, theme)}
          onSelectSlot={parent.onSelectSlot}
          backgroundEvents={parent.getBackgroundEvents(resource)}
        />
      </div>
    );
  })
);

ResourceCalendarView.propTypes = {
  parent: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired
};

export default ResourceCalendarView;
